import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Error, Spinner } from 'src/components';
import { useGetChannelsFromFirestore } from 'src/queries';
import { useQueryHelper } from 'src/queries/utils';
import { useOrganizationState } from 'src/state';

import { Container, Title } from './Channels.styled';
import { ChannelItem } from './components/ChannelItem';

export const Channels: FC = () => {
  const { organizationData } = useOrganizationState();
  const channelsCollection = useGetChannelsFromFirestore(organizationData.hotel);
  const { data: channels, refetch } = channelsCollection;
  const { isLoading, isError } = useQueryHelper({ queries: [channelsCollection] });
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <Spinner global />
    );
  }

  if (isError) {
    return <Error info errorTitle="Brak dostępnych kanalów" action={refetch} />;
  }

  return (
    <>
      <Helmet>
        <title>Hotelspot | Kanały TV</title>
        <meta name="description" content="Hotelspot - Kanały TV" />
      </Helmet>
      <Container>
        <Title>{t('channels_screen.title')}</Title>
        {(!channels || channels?.length === 0) && (
          <Error
            info
            errorTitle="Brak dostępnych numerów"
            errorMessage="Nie dodano numerów kontaktowych"
          />
        )}
        {channels && channels?.sort((a, b) => a.order - b.order).map((item, index) => (
          <ChannelItem
            key={item.id}
            logo={item.logo || ''}
            title={item.title}
            number={item.number}
            order={index + 1}
          />
        ))}
      </Container>
    </>
  );
};
